import { useIsMobile } from "@/utils/use-is-mobile";
import React, { createContext, useContext, ReactNode } from "react";

type InfoState = {
    isMobile: boolean;
}

const InfoContext = createContext<InfoState | null>(null);

export const InfoProvider = ({ children }: { children: ReactNode }) => {
    const isMobile = useIsMobile();

    return (
        <InfoContext.Provider value={{ isMobile }}>
            {children}
        </InfoContext.Provider>
    );
};

export const useInfo = () => {
    const context = useContext(InfoContext);
    if (!context) {
        throw new Error("useInfo must be used within a InfoProvider");
    }
    return context;
};
